export default "__VITE_ASSET__bd6bf834__"